import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/public-pooja-booking.css";

const API_BASE = "https://webcontrol.suvidham.in/api";

export default function PoojaSuccess() {
  const { state } = useLocation();
  const orderNo = state?.order_no || localStorage.getItem("pooja_pending_order") || "";
  const [payment, setPayment] = useState(state?.payment_status || "PENDING");
  const [message, setMessage] = useState(state?.message || "Booking saved. Waiting for payment confirmation.");

  useEffect(() => {
    if (!orderNo || payment === "SUCCESS") return;
    let stopped = false;
    const check = async () => {
      try {
        const r = await fetch(`${API_BASE}/public_payment_status.php?order_no=${encodeURIComponent(orderNo)}`);
        const d = await r.json();
        if (!stopped && r.ok && d.status === "success") {
          setPayment(d.data?.payment_status || "PENDING");
          if (d.data?.payment_status === "SUCCESS") {
            setMessage("Payment successful. Your pooja booking is confirmed.");
            localStorage.removeItem("pooja_cart");
          }
        }
      } catch (_) {}
    };
    check();
    const id = setInterval(check, 5000);
    return () => { stopped = true; clearInterval(id); };
  }, [orderNo, payment]);

  return (
    <div className="pb-page">
      <div className="pb-success">
        <div className="pb-success-icon"><i className={`fa ${payment === "SUCCESS" ? "fa-check" : "fa-clock-o"}`} /></div>
        <h1>{payment === "SUCCESS" ? "Payment Success" : "Booking Received"}</h1>
        <p>{message}</p>
        <div className="pb-success-no"><small>Booking / Order Number</small><strong>{orderNo || "Saved"}</strong></div>
        {state?.total_amount != null && <h2>₹{Number(state.total_amount).toLocaleString("en-IN")}</h2>}
        <p><strong>Payment Status:</strong> {payment}</p>
        <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
          <Link className="pb-pay" to="/pooja-login">Login / View My Bookings</Link>
          <Link className="pb-pay" to="/online-pooja-booking">Book Another Pooja</Link>
        </div>
      </div>
    </div>
  );
}
